// extracted by css-extract-rspack-plugin
export default {"container":"ZPy8ihMkiQ83Y7aN","title":"cPqfR_7aQJY7ezZQ","description":"sAiIYW8Aqz8XGyiz"};